import { config, getAuthToken } from './bridge.js';

const BASE = `${config.backendUrl.replace(/\/$/, '')}/api/monkeywheel`;

async function authedFetch(path, options = {}) {
  const token = await getAuthToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  // Measure request round-trip so callers can pass an accurate RTT to
  // applyServerNow() for half-RTT bias correction (NTP-style).
  const _t0 = Date.now();
  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  let body = null;
  try { body = await res.json(); } catch (e) {}
  const _rttMs = Date.now() - _t0;
  if (!res.ok) {
    const err = new Error((body && body.error) || `http_${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  if (body && typeof body === 'object') {
    try { Object.defineProperty(body, '_rttMs', { value: _rttMs, enumerable: false }); } catch (e) {}
  }
  return body;
}

export const api = {
  getConfig: () => authedFetch('/config'),
  getBalance: () => authedFetch('/balance'),
  getCurrentRound: () => authedFetch('/round/current'),
  getRound: (id) => authedFetch(`/round/${id}`),
  getHistory: (limit = 20) => authedFetch(`/history?limit=${limit}`),
  getActivity: (limit = 20) => authedFetch(`/activity?limit=${limit}`),
  getMyBets: (limit = 50) => authedFetch(`/my-bets?limit=${limit}`),
  placeBet: ({ roundId, slotId, amount, clientNonce, clientRttHintMs, clientRemainingMs }) =>
    authedFetch('/bet', {
      method: 'POST',
      body: JSON.stringify({
        roundId, slotId, amount, clientNonce,
        clientRttHintMs: typeof clientRttHintMs === 'number' && isFinite(clientRttHintMs) ? clientRttHintMs : null,
        clientRemainingMs: typeof clientRemainingMs === 'number' && isFinite(clientRemainingMs) ? clientRemainingMs : null,
      }),
    }),
  placeBetBatch: ({ roundId, taps, batchNonce, clientRttHintMs, clientRemainingMs }) =>
    authedFetch('/bet/batch', {
      method: 'POST',
      body: JSON.stringify({
        roundId,
        taps: Array.isArray(taps) ? taps : [],
        batchNonce,
        clientRttHintMs: typeof clientRttHintMs === 'number' && isFinite(clientRttHintMs) ? clientRttHintMs : null,
        clientRemainingMs: typeof clientRemainingMs === 'number' && isFinite(clientRemainingMs) ? clientRemainingMs : null,
      }),
    }),
  // Fire-and-forget client telemetry. The `events` array is logged on the
  // server as monkeywheel_client_diag entries so any silent client-side failure
  // (e.g. queued taps that didn't reach POST /bet/batch) still shows up on Railway.
  diag: (events) => authedFetch('/diag', {
    method: 'POST',
    body: JSON.stringify({ events: Array.isArray(events) ? events : [events] }),
  }),
};
